import { ECurrency, symbolCurrency } from '@lbs/currency'
import { Button, List, ListItem, TextField } from '@mui/material'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { matchIsValidTel, MuiTelInput } from 'mui-tel-input'
import { FC, useState } from 'react'
import { toast } from 'react-toastify'
import Players from '../../api/players'
import { formPropsDrawerCrud } from '../../constants/formPropsDrawerCrud'
import { useStore } from '../../stores'
import CreatePlayerStore from '../../stores/CreatePlayer.store'
import { Select, WrapDrawerCreateForm } from '../index'

const PlayerCreate: FC = observer(() => {
  const { drawerCRUDStore } = useStore()
  const player = useLocalObservable(() => {
    return new CreatePlayerStore({})
  })
  const [gameRatioInput, setGameRatioInput] = useState<string>(String(player.gameRatio))

  return (
    <WrapDrawerCreateForm
      title="Создание нового игрока"
      onSave={async () => {
        try {
          const { login, phones, currency, gameRatio } = player

          await Players.createPlayer({
            login,
            phones: [
              ...phones.map((item) => ({
                number: item.number.replace(/\s/g, ''),
                priority: item.priority,
              })),
            ],
            currency,
            gameRatio,
          })

          drawerCRUDStore.resetView()
        } catch (e: any) {
          toast.error(`Failed create player`)
        }
      }}
      disabledSave={!player.login || !player.phones.length}>
      <TextField
        {...formPropsDrawerCrud}
        value={player.login}
        onChange={(e) => player.updateFields({ login: e.target.value })}
        label="Логин"
      />
      <Select
        {...formPropsDrawerCrud}
        id="currency"
        label="Валюта"
        value={player.currency}
        options={Object.values(ECurrency).map((item) => {
          return {
            value: item,
            label: `${symbolCurrency[item]} (${item})`,
          }
        })}
        onChange={(e) => {
          player.updateFields({ currency: e as ECurrency })
        }}
      />
      <TextField
        {...formPropsDrawerCrud}
        value={gameRatioInput}
        type="number"
        inputProps={{ min: 1, step: 1 }}
        onChange={(e) => {
          const { value } = e.target
          setGameRatioInput(value)
          if (value !== '' && Number(value) >= 1) {
            player.updateFields({ gameRatio: Number(value) })
          }
        }}
        onBlur={() => {
          if (gameRatioInput === '' || Number(gameRatioInput) < 1) {
            setGameRatioInput('1')
            player.updateFields({ gameRatio: 1 })
          }
        }}
        label="Коэффициент для игр"
      />
      <List>
        {player.phones.map((item, index) => {
          const isInvalidPhone = player.phones[index].number.length > 0 && !matchIsValidTel(player.phones[index].number)
          return (
            <ListItem disablePadding key={item.priority}>
              <MuiTelInput
                {...formPropsDrawerCrud}
                error={isInvalidPhone}
                helperText={isInvalidPhone ? 'Номер не валиден' : ''}
                value={player.phones[index].number}
                onChange={(e) => {
                  player.changeNumber(e, index)
                }}
              />
            </ListItem>
          )
        })}
      </List>
      <Button
        type="button"
        variant="outlined"
        onClick={(e) => {
          e.preventDefault()

          player.addPhone()
        }}>
        Добавить номер
      </Button>
    </WrapDrawerCreateForm>
  )
})

export default PlayerCreate
